import React from 'react';
import ConfirmModal from 'js/components/modal/ConfirmModal';
import { Alert } from 'reactstrap';
import { Icon } from 'js/components';
import { pluralize } from 'js/utils/string';

function MoveNodeConfirmDialog({
  nodeToMove,
  targetNode,
  intermediateRoots,
  isOpen,
  onCancel,
  onConfirm,
}) {
  const typeForMove = nodeToMove?.type === 'team' ? 'team' : 'group';
  const roots = intermediateRoots ?? [];
  const rootNames = roots.map((root) => root.name);

  return (
    <ConfirmModal
      onConfirm={onConfirm}
      onCancel={onCancel}
      isOpen={isOpen}
      confirmButtonLabel="Move"
      title={`Move ${typeForMove}?`}
    >
      <Alert color="info">
        <div className="org-change-warning">
          <Icon icon="exclamation-circle" />
          <span>
            This change will affect the{' '}
            {pluralize(rootNames.length, 'organization', 'organizations')}{' '}
            <strong>{rootNames.join(', ')}</strong> and any organizations that
            refer to {pluralize(rootNames.length, 'it', 'them')}.
          </span>
        </div>
      </Alert>
      <p>
        Move <strong>{nodeToMove?.name}</strong> to{' '}
        <strong>{targetNode?.name}</strong>?
      </p>
    </ConfirmModal>
  );
}

export default MoveNodeConfirmDialog;
